/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef} from 'react'
import DriverDocuments from './DriverDocumentsCompliance'
import VanDocuments from './VanDocumentsCompliance'
import { useSelector, useDispatch } from 'react-redux';
// import {
//     addComplianceCheckData,
//     selectComplianceCheck
// } from '../features/compliancecheck/complianceCheckSlice'
import { 
    addDrivers,
    selectDrivers
} from '../features/drivers/driversSlice'
import {
    addImages,
    selectImages
} from '../features/imagesSliceFile/imagesSlice'
import {
    addVehicle, 
    selectVehicles
} from '../features/vehicles/vehiclesSlice'


const ComplianceCheck = (props) => {
    // redux
    const dispatch = useDispatch()
    // const complianceReduxData = useSelector(selectComplianceCheck)

    const reduxDrivers = useSelector(selectDrivers)
    const imageData = useSelector(selectImages)
    const vehicleData = useSelector(selectVehicles)

    var CryptoJS = require("crypto-js");
    const [ topRow, setTopRow ] = useState([])
    const [ data, setData ] = useState(null)
    const [ midSection, setMidSection ] = useState(null)
    const [ reload, setReload ] = useState(false)
    const [ drivers, setDrivers ] = useState([])
    const [ images, setImages ] = useState([])
    const [ vehicles, setVehicles ] = useState([])

    useEffect( () => {
        if (reduxDrivers.length > 0 && imageData.length > 0 && vehicleData.length > 0) {
            setDrivers([...reduxDrivers])
            setImages([...imageData])
            setVehicles([...vehicleData])
        } else {
            reload ? setReload(false) : setReload(true)
        }
    }, [])

    // my pageref
    const verticalRef = useRef(0)
    const horizontalRef = useRef(0)

    // grab the main data
    useEffect( () => {
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });

            return response ? response.json() : console.log('no reponse')

        };

        getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
            setDrivers(response.results)
            getData('https://backendpajamas.herokuapp.com/vehicles/').then( response => {
                setVehicles(response.results)
                getData('https://backendpajamas.herokuapp.com/images/').then( response => {
                    setImages(response.results)
                })
            })
        })

    }, [reload])

    // handle mapping the data
    useEffect( () => {
        let localDriverArray = []
        let localVehicleArray = []
        if (drivers.length > 0 && images.length > 0 && vehicles.length > 0) {
            drivers.forEach( driver => {
                let localDriver = {...driver}
                localDriver.imgArray = []
                images.forEach( image => {
                    if (image.driver_id === `https://backendpajamas.herokuapp.com/drivers/${driver.driver_id}/`) {
                        localDriver.imgArray.push(image)
                    }
                })
                localDriverArray.push(localDriver)
            })
            vehicles.forEach( vehicle => {
                let localVehicle = {...vehicle}
                localVehicle.imgArray = []
                images.forEach( image => {
                    if (`https://backendpajamas.herokuapp.com/vehicles/${vehicle.vehicle_id}/` === image.vehicle_id) {
                        localVehicle.imgArray.push(image)
                    }
                })
                localVehicleArray.push(localVehicle)
            })
        }
        setData({
            "drivers": localDriverArray,
            "vehicles": localVehicleArray
        })
    }, [drivers, images])

    useEffect( () => {
        setMidSection(
            <div className='row_container_bottom'>
                <div className='driverDocsComplianceSection'>
                    <DriverDocuments 
                        data={data}
                        selectedCity={props.selectedCity}
                    />
                </div>
                <div className='driverDocsComplianceSectionVans'>
                    <VanDocuments 
                        data={data}
                        selectedCity={props.selectedCity}
                    />
                </div>
            </div>
        )
    }, [data, props.selectedCity])

    // function for making the grid
    useEffect( () => {

        // top row list of catagories
        let documentList = [
            'Passport / ID / BC',
            'Country of issue',
            'Expiry Date',
            'VISA Expiry Date',
            'Driving License Country Issue',
            'Expiry Date',
            'DVLA Check Expiry Date',
            'BGC',
            'D&A Date Passed',
            'App Pack',
            'NIN',
            'UTR',
            'P.O.A',
            'VAT'
        ]
        let vanList = [
            'Van Owner',
            'Reg Number',
            'Vehicle Type',
            'MOT Expire Date',
            'Motor Insurance Expiry Date',
            'G.I.T. Insurance Expiry Date',
            'P.L. Insurance Expiry Date',
            'V5',
            'Tax Due Date',
        ]
        
        // function for making the top row
        const makeTopRow = () => {
            let localArray = []
            localArray.push(
                <div key={831} className='labels_for_compliance_check_name' id='firstName'>
                    DA Name
                </div>
            )
            documentList.forEach( (label, labelID) => {
                if (label === 'Passport / ID Card') {
                    localArray.push(
                        <div className='labels_for_compliance_check_documents'>
                            {label}
                        </div>
                    )
                } else {
                    localArray.push(
                        <div className='labels_for_compliance_check_documents'>
                            {label}
                        </div>
                    )
                }
            })
            vanList.forEach( (label, labelID) => {
                localArray.push(
                    <div className='labels_for_compliance_check_vans'>
                        {label}
                    </div>
                )
            })
            return localArray
        }
        // set the rows into state for display
        setTopRow(makeTopRow()) 
    }, [])

    // the scrolling part
    const handleScroll = (e) => {
        
    }

    return (
        <div className='compliance_check_container' onScroll={handleScroll}>
            <div className='row_container'>
                {topRow}
            </div>
            {midSection}
        </div>
    )
}

export default ComplianceCheck